import { useEffect, useState } from 'react'
import Button from 'react-bootstrap/Button'
import Modal from 'react-bootstrap/Modal'

import Toast from 'components/atoms/Toast'
import { easternDay } from 'helpers/dates'
import { useOverrideDeviceFirstCheckOutMutation } from 'store/services/devices'

interface IProps {
  show: boolean
  deviceId: number
  firstCheckedOutAt?: string | Date | null
  onClose: () => void
}

// TES-3191: for used devices that were in service before they reached us; only users allowed to
// override shelf life see it.
export const FirstCheckOutModal = ({ show, deviceId, firstCheckedOutAt, onClose }: IProps) => {
  const [day, setDay] = useState('')
  const [override, { isLoading }] = useOverrideDeviceFirstCheckOutMutation()
  const today = easternDay(new Date())

  useEffect(() => {
    if (show) setDay(easternDay(firstCheckedOutAt))
  }, [show, firstCheckedOutAt])

  const save = async () => {
    try {
      await override({ id: deviceId, firstCheckOutDate: day }).unwrap()
      Toast({ type: 'success', label: 'First Check-Out Date updated' })
      onClose()
    } catch (error: any) {
      Toast({ type: 'error', label: error?.data?.message || 'Failed to update the First Check-Out Date' })
    }
  }

  return (
    <Modal centered show={show} onHide={onClose}>
      <Modal.Header>
        <Modal.Title>Set First Check-Out Date</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p className="text-muted mb-2">
          For a used device that was already in service before it reached us. The expiration date
          moves with it.
        </p>
        <label htmlFor="firstCheckOutDate" className="textGray">
          First Check-Out Date
        </label>
        <input
          id="firstCheckOutDate"
          type="date"
          className="form-control"
          value={day}
          max={today}
          onChange={(event) => setDay(event.target.value)}
        />
      </Modal.Body>
      <Modal.Footer>
        <Button variant="outline-secondary" onClick={onClose}>
          Cancel
        </Button>
        <Button onClick={save} disabled={!day || day > today || isLoading}>
          Save
        </Button>
      </Modal.Footer>
    </Modal>
  )
}
